import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

const appMeta = { layout: "AppLayout" };

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: "/",
            redirect: "/home",
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/views/LoginView.vue"),
            meta: { allowAnonymous: true, disallowConnected: true },
        },
        {
            path: "/home",
            name: "home",
            component: () => import("@/views/HomeView.vue"),
            meta: appMeta,
        },
        {
            path: "/aquariums",
            name: "aquariums",
            component: () => import("@/views/AquariumsView.vue"),
            meta: appMeta,
        },
        {
            path: "/plants",
            name: "plants",
            component: () => import("@/views/PlantsView.vue"),
            meta: appMeta,
        },
        {
            path: "/profile",
            name: "profile",
            component: () => import("@/views/ProfileView.vue"),
            meta: appMeta,
        },
    ],
});

router.beforeEach((to, _from, next) => {
    const auth = useAuthStore();

    if (auth.isAuthenticated) {
        if (to.meta.disallowConnected) {
            next({ name: "home" });
            return;
        }
    } else {
        if (!to.meta.allowAnonymous) {
            next({ name: "login" });
            return;
        }
    }

    next();
});

export default router;
